import { ONBOARDING_CONNECT_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
export const ConnectOrganizationMessage = (props) => {
    const { customerName, organizationName, salesforceUserName } = props;
    return (React.createElement("p", null,
        React.createElement("b", null, customerName),
        ONBOARDING_CONNECT_COPY.PARTIAL_WILL_LINK_TO,
        React.createElement("b", null, organizationName),
        ONBOARDING_CONNECT_COPY.PARTIAL_SALESFORCE_ORGANIZATION_USING,
        React.createElement("i", null, salesforceUserName),
        ONBOARDING_CONNECT_COPY.PARTIAL_CREDENTIALS));
};
